import React from 'react';
import styles from '../../../styles/widgets/import-portfolio/import-portfolio-heading.module.scss';

export const withMABHeader = Component => props => <Component headingClassName={styles.heading} {...props} />;
